module.exports = __webpack_public_path__ + "static/img/kf.f2338710.png";